export default "__VITE_ASSET__5d2f8386__"